import {createApp} from "petite-vue";

import videoItem from './directives/global/video-item';


import device from "./services/device";
import interact from "./services/interact";
import Analytics from "./services/Analytics";

import Disclaimer from "./components/Disclaimer";
import Newsletter from "./components/Newsletter";
import Complete from "./components/Complete";
import Grabber from "./components/Grabber";
import Dating from "./components/Dating";
import Flying from "./components/Flying";
import Article from "./components/Article";
import ArticleGallery from "./components/ArticleGallery";
import PhotoGallery from "./components/PhotoGallery";
import Player from "./components/Player";
import Native from "./components/Native";
import Login from "./components/Login";
import Channel from "./components/Channel";
import Actor from "./components/Actor";
import ActorSuggest from "./components/ActorSuggest";
import Video from "./components/Video";
import VideoFilter from "./components/VideoFilter";
import VideoPlaylist from "./components/VideoPlaylist";
import VideoReport from "./components/VideoReport";
import Short from "./components/Short";

import LazyDirective from './directives/global/LazyDirective';
import BannerChoiceDirective from "./directives/global/BannerChoiceDirective";
import BannerOwnerDirective from "./directives/global/BannerOwnerDirective";
import BackgroundDirective from "./directives/global/BackgroundDirective";
import DropDirective from "./directives/global/DropDirective";
import RollDirective from "./directives/global/RollDirective";
import HeaderDirective from './directives/global/HeaderDirective';
import FollowDirective from "./directives/global/FollowDirective";
import ToggleDirective from "./directives/global/ToggleDirective";
import IncludeDirective from './directives/global/IncludeDirective';
import IntersectDirective from './directives/global/IntersectDirective';
import PreviewDirective from './directives/global/PreviewDirective';
import ReaderDirective from "./directives/global/ReaderDirective";
import UnderDirective from "./directives/global/UnderDirective";
import CaptchaDirective from "./directives/global/CaptchaDirective";
import ShortDirective from "./directives/global/ShortDirective";



const params = new URLSearchParams({
    device: device.detect().label,
    height: window.screen.availHeight,
    width: window.screen.availWidth,
    page: window.variables.banners.page,
    id: window.variables.banners.id,
});

fetch('/service/index.json?' + params.toString())
    .then((r) => r.json())
    .then((r) => {

        window.app = createApp({
            loginFormShown: false,
            blocked: false,
            language: window.variables.language,
            alternates: window.variables.alternates,
            device: device.detect(),
            service: r.payload,
            interacted: false,
            preview: false,
            observer: {
                home: {
                    short: false,
                },
                video: {
                    comments: false,
                    stream: false,
                },
                footer: {
                    banner: false,
                    about: false,
                    legal: false,
                    paper: false,
                }
            },
            reader: {
                header: null,
                footer: null,
                filter: false,
                profile: false,
            },
            complete: {
                actor: {
                    results: [],
                    counter: 0,
                    text: null,
                },
                channel: {
                    results: [],
                    counter: 0,
                    text: null,
                },
                global: {
                    results: [],
                    counter: 0,
                    text: null,
                },
                suggest: {
                    results: [],
                    counter: 0,
                    text: null,
                },
            },
            template: {},
            mounted() {
                // Footer
                device.event((o) => {
                    this.service.footer.information.visible = !this.device.mobile;
                    this.service.footer.account.visible = !this.device.mobile;
                    this.service.footer.partner.visible = !this.device.mobile;
                    this.service.footer.follow.visible = !this.device.mobile;
                    this.device = o;
                });
                // Age gate
                if ( this.service.age_gate.visible === false ) {
                    this.service.banners.available = this.service.banners.discovered;
                }

                // Interacted
                interact.event((o) => {
                    this.interacted = true;
                    Analytics.load(this.service.user.country.code);
                });

                let ins = document.querySelector('ins.advertisement-box');
                this.blocked = typeof ins === "undefined" || (ins.offsetHeight + ins.offsetWidth ) === 0;

                // Test the new async script from exo
                setTimeout(() => {
                    let script = document.createElement('script');
                    script.src = 'https://a.magsrv.com/ad-provider.js';
                    script.async = true;
                    script.onload = () => {
                        (window.AdProvider = window.AdProvider || []).push({"serve": {}});
                    }
                    document.getElementsByTagName('head')[0].appendChild(script);
                }, 500);
                // this.beforeYouGo();
            },
            backToTop()  {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            },
            /**
             * https://stackoverflow.com/questions/14215079/ajax-with-history-pushstate-and-popstate-what-do-i-do-when-popstate-state-prop
             */
            beforeYouGo() {
                window.history.pushState({}, null,  '#hVyg');
                window.addEventListener('popstate', function(event) {
                     this.modules.display.beforeYouGo = true;
                }, {passive: true });

            },
            modules: {
                hover: false,
                timeout: 0,
                display: {
                    aside: false,
                    alternates: false,
                    cookies: false,
                    beforeYouGo: false,
                },
                sidebar: {
                    actor: false,
                    genre: false,
                    video: false,
                    channel: false,
                    category: false,
                    language: false,
                },
                footer: {
                   information: false,
                   account: false,
                   partner: false,
                   follow: false,
                },
                video: {
                    filter: false,
                }
            },
            bunny: {
                active: false,
                loading: false,
                load() {
                    this.loading = true;
                },
            },
            login: {
                loaded: false,
                visible: false,
                close() {
                    this.visible = false;
                },
            },

            Disclaimer,
            Newsletter,
            Complete,
            Grabber,
            Dating,
            Flying,
            PhotoGallery,
            Article,
            ArticleGallery,
            Player,
            Native,
            Login,
            Channel,
            Actor,
            ActorSuggest,
            Video,
            VideoFilter,
            VideoPlaylist,
            VideoReport,
            Short,
        });


        app.directive('banner-choice', BannerChoiceDirective);
        app.directive('banner-owner', BannerOwnerDirective);
        app.directive('lazy', LazyDirective);

        app.directive('include', IncludeDirective);
        app.directive('intersect', IntersectDirective);
        app.directive('preview', PreviewDirective);
        app.directive('reader', ReaderDirective);
        app.directive('follow', FollowDirective);
        app.directive('toggle', ToggleDirective);
        app.directive('header', HeaderDirective);
        app.directive('background', BackgroundDirective);
        app.directive('drop', DropDirective);
        app.directive('roll', RollDirective);
        app.directive('under', UnderDirective);
        app.directive('captcha', CaptchaDirective);
        app.directive('video-item', videoItem);
        app.directive('short', ShortDirective);


        app.directive('remove', (vue) => {
            vue.effect((x) => {
                if ( vue.get() === true ) {
                    vue.el.remove();
                }
            })
        });
        app.mount();

    })
    .catch();
